import React, { useEffect, useState } from "react";
import {
  Modal,
  IconButton ,
  Typography,
  Card,
  Grid,
  InputLabel,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Tooltip,
  CircularProgress,
  Alert, 
  AlertTitle,
  MenuItem,
  Slider,
  Box,
  Autocomplete,
  TextField
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import {  getSalesOffices,GetMaterialListByPlant,GetBeverageProduct,GetPackSizes,GetPackTypes,GetBottleCanConfiguration} from "../../utils/GetAdmin";
import { materialText,GetAllMaterialText } from "../../utils/GetAML"
import {checkForRole} from "../../utils/GetAuth";
import { saveBottleCanConfiguration} from "../../utils/PostAdmin";
import requestMissingContexts, {determineConfigLong,determineConfig,displayConfig} from "../../utils/GetContext";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import LockIcon from '@mui/icons-material/Lock';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import Clear from "@mui/icons-material/Clear";
import Help from "@mui/icons-material/Help";
import Select, { SelectChangeEvent } from '@mui/material/Select';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
  };
}


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle:{
      color: theme.palette.primary.main,
    },
    modalCard: {
    },
    modalText: {
      width: 800,
    },
    modalInput: {
      paddingLeft: "2px", 
      paddingRight: "20px", 
      width:"300px"
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
  })
);
interface filterRowMaterial {
  searchMaterial: any;
}
interface filterRowBeverageProduct {
  searchBeverageProduct: any;
}
export default function BottleCanConfig() {

    const classes = useStyles();
    const [codes, setCodes] = React.useState<any>();
    const [deliveringPlants, setDeliveringPlants] = React.useState<any>();
    const [rowDeliveryPlant, setRowDeliveringPlants] = React.useState<any>("*");
    const [rowTypeOveride, setRowTypeOveride] = React.useState<any>("bottle");
    const [rowMachineType, setRowMachineType] = React.useState<any>("stack");
    const [rowGroup, setRowGroup] = React.useState<any>("material_number");
    const [rowMaterialNumber, setrowMaterialNumber] = useState<filterRowMaterial>({
     searchMaterial: null,
    });
    const [rowBeverageProduct, setRowBeverageProduct] = useState<filterRowBeverageProduct>({
      searchBeverageProduct: null,
     });
    const [rowPackSize, setRowPackSize] = React.useState<any>();
    const [rowPackType, setRowPackType] = React.useState<any>();

    const [materialList,setMaterialList] = useState<any[]>([]);
    const [categoryList, SetCategoryList] = useState<any[]>([]);
    const [productList, SetProductList] = useState<any[]>([]);
    const [packSizeList, SetPackSizeList] = useState<any[]>([]);
    const [packTypeList, SetPackTypeList] = useState<any[]>([]);

    const [bottleCanConfig, SetBottleCanConfig] = useState<any[]>([]);
    const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
    const [doneLoading, setDoneLoading] = React.useState<boolean>();
    const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
    const enabled = checkForRole(clientId,salesOrg,'vp_admin');
    const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
    const [useCompact] = useLocalStorage("SETTINGS.compact", true);
    const [mode,setMode] = React.useState<any>("add");
    const [rowGuid, setRowGuid] = React.useState<any>();

   
    const handleDelete = () => {
      let newmapdata = { delivery_plant: rowDeliveryPlant,
        type_override:rowTypeOveride,
        machine_type:rowMachineType,
        group_by:rowGroup,
        material_num:rowMaterialNumber.searchMaterial?rowMaterialNumber.searchMaterial.material_num:'',
        beverage_product:rowBeverageProduct.searchBeverageProduct.code,
        pack_type:rowPackType,
        pack_size:rowPackSize,
      guid:rowGuid};
        saveBottleCanConfiguration(salesOrg,newmapdata,undefined).then((ret:any) => {
        if(ret && ret.bottleCanConfig){
          SetBottleCanConfig(ret.bottleCanConfig);
          if(ret.data.message){
            alert(ret.data.message);
          }
        }
      });
      setEditedRow(undefined);
    }
    const setCurrent = (editedRow:any) => {
     // console.log(editedRow);
      setMode('edit');
      setEditedRow(editedRow);
      setRowGuid(editedRow.guid);
      setRowDeliveringPlants(editedRow.delivery_plant);
      setRowTypeOveride(editedRow.type_override);
      setRowMachineType(editedRow.machine_type);
      setRowGroup(editedRow.group_by);
      var selectedMaterial = materialList.find(
        (mat) => mat.material_num === editedRow.material_num
      );
      setrowMaterialNumber({
        searchMaterial: selectedMaterial,
       }); 
    
      var selectedProduct = productList.find(
        (product) => product.code === editedRow.beverage_product
      );
    setRowBeverageProduct({
      searchBeverageProduct: selectedProduct,
     });
     
      setRowPackSize(editedRow.pack_size);
      setRowPackType(editedRow.pack_type);
      //seteditedRowitemsPerRow(editedRow.items_per_row);
      
    }
    const clearCurrent = () => {
      setEditedRow(undefined);
      setRowDeliveringPlants("*");
      setRowTypeOveride("bottle");
      setRowMachineType("stack");
      setRowGroup("material_number");
      setrowMaterialNumber({
        searchMaterial: null,
       });
      setRowBeverageProduct({
        searchBeverageProduct: null,
       });
      setRowPackSize("");
      setRowPackType("");
    }
    const handleEdit = (editedRow:any) => {
      clearCurrent();
      setCurrent(editedRow);
      setOpenEditWindow(true);
    }
    const [editedRow, setEditedRow] = React.useState<any|undefined>(undefined);
    const [modalStyle] = React.useState(getModalStyle);
    const [openDeleteWindow, setopenDeleteWindow] = React.useState(false);
    const [openEditWindow, setOpenEditWindow] = React.useState(false);
    const handleModalClose = () => {
      setOpenEditWindow(false);
      clearCurrent();
      setEditedRow(undefined);
    }

    const handleModalSave = () => {
      
     let newmap = { delivery_plant: rowDeliveryPlant,
      type_override:rowTypeOveride,
      machine_type:rowMachineType,
      group_by:rowGroup,
      material_num:rowMaterialNumber.searchMaterial?rowMaterialNumber.searchMaterial.material_num:'',
      beverage_product:rowBeverageProduct.searchBeverageProduct.code,
      pack_type:rowPackType,
      pack_size:rowPackSize,
      guid:rowGuid
    };

      const selectedOption = packTypeList.find((option) => option.code === rowPackType);
      if (selectedOption.text.includes("CN") && rowTypeOveride==='can') {
       // alert('CAN Type Material can not be overided as CAN'); return
      } else if(selectedOption.text.includes("BT") && rowTypeOveride==='bottle') {
        //alert('BOTTLE Type Material can not be overided as BOTTLE');return
      }
      saveBottleCanConfiguration(salesOrg,undefined,newmap).then((ret:any) => {
        if(ret && ret.bottleCanConfig) SetBottleCanConfig(ret.bottleCanConfig);
        
      });

      setOpenEditWindow(false);
      setEditedRow(undefined);
      setRowGuid(undefined);
    } 
    useEffect(() => {
      if (doneLoading) return;
      requestMissingContexts([
        "PACKTYPE",
        "PACKSIZE",
        "SALESOFFICES",
        "BEVERAGEPRODUCT",
      ])
        .then((v) => {
          setCodes(v);
        })
      GetBottleCanConfiguration(salesOrg).then((v) => {
        if(v && v.bottleCanConfig) SetBottleCanConfig(v.bottleCanConfig);
      })
      getSalesOffices(salesOrg).then((v) => {
        setDeliveringPlants(v);
      });

      const handleDataLoad = () => {
        if(rowGroup==="material_number"){
          GetMaterialListByPlant(salesOrg,rowDeliveryPlant).then((v) => {
            setDoneLoading(true);
            if(v) setMaterialList(v);
          })
          GetBeverageProduct(salesOrg).then((v) => {
            setDoneLoading(true);
            if(v )
             SetProductList(v.mdEquipmentModelMap);
          })
        }else{
          setMaterialList([]);
        }

      }

      handleDataLoad();
    GetPackSizes(salesOrg).then((v) => {
        setDoneLoading(true); 
        if(v && v.mdEquipmentModelMap) SetPackSizeList(v.mdEquipmentModelMap);
      }).then((_) => {
        GetPackTypes(salesOrg).then((v) => {
           setDoneLoading(true);
          if(v && v.mdEquipmentModelMap) SetPackTypeList(v.mdEquipmentModelMap);
        })
        
      });
    }, [doneLoading,salesOrg,rowGroup]);
   
    const setMaterialNumber = (material_num:string) => {
      GetBeverageProduct(salesOrg,material_num).then((v) => {
        setDoneLoading(true);
        if(v )
         //SetCategoryList(v.mdEquipmentModelMap);
         var selectedProduct = productList.find(
            (product) => product.code === v.mdEquipmentModelMap[0].code
          );
        setRowBeverageProduct({
          searchBeverageProduct: selectedProduct,
         });
      })
      GetPackSizes(salesOrg,material_num).then((v) => {
        setDoneLoading(true); 
        if(v && v.mdEquipmentModelMap) SetPackSizeList(v.mdEquipmentModelMap);
        setRowPackSize(v.mdEquipmentModelMap[0].code);
      }).then((_) => {
        GetPackTypes(salesOrg,material_num).then((v) => {
           setDoneLoading(true);
          if(v && v.mdEquipmentModelMap) SetPackTypeList(v.mdEquipmentModelMap);
          setRowPackType(v.mdEquipmentModelMap[0].code);
        })
        
      });
    }
    const setGroup = (option:string) => {
      setRowGroup(option);
      setDoneLoading(false);
      if(option==="material_number"){
       // setMode('add');
        GetMaterialListByPlant(salesOrg,rowDeliveryPlant).then((v) => {
          setDoneLoading(true);
          if(v) setMaterialList(v);
        })
      }else{
        setMaterialList([]);
        setrowMaterialNumber({
          searchMaterial: null,
         });
         //setMode('edit');
        GetBeverageProduct(salesOrg).then((v) => {
          setDoneLoading(true);
          if(v)
           SetCategoryList(v.mdEquipmentModelMap);
         // setMaterialList([]);
        })
        GetPackSizes(salesOrg).then((v) => {
          setDoneLoading(true); 
          if(v && v.mdEquipmentModelMap) SetPackSizeList(v.mdEquipmentModelMap);
        }).then((_) => {
          GetPackTypes(salesOrg).then((v) => {
             setDoneLoading(true);
            if(v && v.mdEquipmentModelMap) SetPackTypeList(v.mdEquipmentModelMap);
          })
          
        });
      }
      }  

      const getPackDetails = (bpp:string) => { 
        GetPackSizes(salesOrg,'',bpp).then((v) => {
          setDoneLoading(true); 
          if(v && v.mdEquipmentModelMap) SetPackSizeList(v.mdEquipmentModelMap);
          setRowPackSize(v.mdEquipmentModelMap[0].code);
        }).then((_) => {
          GetPackTypes(salesOrg,'',bpp).then((v) => {
             setDoneLoading(true);
            if(v && v.mdEquipmentModelMap) SetPackTypeList(v.mdEquipmentModelMap);
            setRowPackType(v.mdEquipmentModelMap[0].code);
          })
          
        });
      }  
      
    const modalBody = (
      <div style={modalStyle} className={classes.paper} >
      <Typography variant="h4" className={classes.modalTitle} paragraph>Add Bottle/Can Configuration:</Typography>
      <Grid container spacing={2}  className={classes.modalGrid}>
        <Grid item xs={14} md={14} xl={12}>
          <Typography variant="subtitle1" className={classes.modalText} paragraph>
          </Typography>
          <Card className={classes.modalCard}>
            <CardContent>
            <Grid container rowSpacing={3} className={classes.modalGrid}>
              <Grid item xs={6} md={6} xl={6}>
                <InputLabel >Delivery Plant <Tooltip title="Configuration is applicable on delivery plant.(This configuration is used to overide machine type (BOTTLE/CAN/Mix))">
                <Help style={{paddingBottom: "7px", textAlign:"center"}} /></Tooltip></InputLabel>
                <Select label="Delivery Plant" required placeholder='Delivery Plant'  value={rowDeliveryPlant}
                    inputProps={{name: 'Delivery Plant',}}
                    className={classes.modalInput}
                    onChange={(e) => { 
                      setRowDeliveringPlants(e.target.value);
                      }}
                    >
                    <MenuItem key="*" value="*"> All</MenuItem>
                    {(deliveringPlants)?(Object.entries(deliveringPlants).map((so: any, i: number) => (
                      
                        <MenuItem key={so[1].code} value={so[1].code}>
                          {so[1].code}-{ so[1].text}
                        </MenuItem>
                        ))):(<div></div>)}
                </Select>
              </Grid>
              <Grid item xs={3} md={6} xl={6}>
                <InputLabel >Type Override <Tooltip title="Configuration is applicable on delivery plant.(This configuration is used to overide machine type (BOTTLE/CAN/Mix))">
                <Help style={{paddingBottom: "7px", textAlign:"center"}} /></Tooltip></InputLabel>
                <Select label="Type Override"  value={rowTypeOveride}
                    className={classes.modalInput}
                    onChange={(e) => { 
                      setRowTypeOveride((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "*") 
                      }}>
                          <MenuItem key="bottle" value="bottle"> Bottle</MenuItem>
                          <MenuItem key="can" value="can">Can</MenuItem>
                          <MenuItem key="both" value="both">Both</MenuItem>
                </Select>
              </Grid>
              <Grid item xs={3} md={6} xl={6}>
                <InputLabel >Machine Type <Tooltip title="This option to identify machine type">
                <Help style={{paddingBottom: "7px", textAlign:"center"}} /></Tooltip></InputLabel>
                <Select label="Machine Type"  value={rowMachineType}
                    className={classes.modalInput}
                    onChange={(e) => { 
                      setRowMachineType((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "*") 
                      }}>
                      <MenuItem key="stack" value="stack">Stack</MenuItem>
                      <MenuItem key="glass" value="glass">Glass</MenuItem>
                      <MenuItem key="both" value="both">Both</MenuItem>
                </Select>
              </Grid>
              <Grid item xs={3} md={6} xl={6}>
                <InputLabel >Group<Tooltip title="This option is to identify the configuration is on the matrial number or BPP wise. Priority would go to Material Number if same configuration would be be available in the system">
                <Help style={{paddingBottom: "7px", textAlign:"center"}} /></Tooltip></InputLabel>
                <Select label="Group"  value={rowGroup}
                    className={classes.modalInput}
                    
                    onChange={(e) => { 
                      setGroup(e.target.value)
                      }}
                      disabled={mode === 'edit'}>
                      <MenuItem key='material_number' value='material_number'>Material Number</MenuItem>
                      <MenuItem key='bpp' value='bpp'>BPP</MenuItem>
                </Select>
              </Grid>
              <Grid item xs={3} md={6} xl={6}>
               <InputLabel >Material Number</InputLabel>
                <Autocomplete
                options={materialList}
                className={classes.modalInput}
                style={{ width: "320px" }}
                value={rowMaterialNumber.searchMaterial}
                getOptionLabel={(option: any) => `${parseInt(option.material_num_short)}-${option.description}`}
                onChange={(_, newMat) => {
                  setrowMaterialNumber({ ...rowMaterialNumber, searchMaterial: newMat });
                  setMaterialNumber((newMat) ? newMat.material_num: "");
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter" && (event.target as any).value) {
                    const newMat = (event.target as any).value;
                    setrowMaterialNumber({ ...rowMaterialNumber, searchMaterial: newMat });
                    setMaterialNumber((newMat) ? newMat.material_num: "");
                  }
                }}
                disabled={mode === 'edit'}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search Material"
                    helperText="Select material to be added"
                    variant="standard"
                  />
                )}
              />
               
              </Grid>
              <Grid item xs={3} md={6} xl={6}>
                <InputLabel >Beverage Product</InputLabel>
                <Autocomplete
                options={categoryList}
                className={classes.modalInput}
                style={{ width: "320px" }}
                value={rowBeverageProduct.searchBeverageProduct}
                getOptionLabel={(option: any) => `${option.code}-${option.text}`}
                onChange={(_, newBP) => {
                  setRowBeverageProduct({ ...rowBeverageProduct, searchBeverageProduct: newBP });
                  getPackDetails((newBP) ? newBP.code: "");
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter" && (event.target as any).value) {
                    const newBP = (event.target as any).value;
                    setRowBeverageProduct({ ...rowBeverageProduct, searchBeverageProduct: newBP });
                    getPackDetails((newBP) ? newBP.code: "");
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search Beverage Product"
                    helperText="Select beverage product to be added"
                    variant="standard"
                  />
                )}
              />
                
              </Grid>
              <Grid item xs={3} md={6} xl={6}>
                <InputLabel >Pack Size</InputLabel>
                <Select label="Pack Size"  value={rowPackSize}
                    className={classes.modalInput}
                    onChange={(e) => { 
                      setRowPackSize((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "*") 
                      }}
                      required>
                    
                    {(packSizeList)?(Object.entries(packSizeList).map((so: any, i: number) => (
                        <MenuItem key={so[1].code} value={so[1].code}>
                        {so[1].code}-{so[1].text}
                        </MenuItem>
                        ))):(<div></div>)}
                </Select>
              </Grid>
              <Grid item xs={3} md={6} xl={6}>
                <InputLabel >Pack Type</InputLabel>
                <Select label="Pack Type"  value={rowPackType}
                    className={classes.modalInput}
                    onChange={(e) => { 
                      setRowPackType((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "*") 
                      }}
                      required>

                    {(packTypeList)?(Object.entries(packTypeList).map((so: any, i: number) => (
                        <MenuItem key={so[1].code} value={so[1].code}>
                          {so[1].code}-{so[1].text_long}
                        </MenuItem>
                        ))):(<div></div>)}
                </Select>
              </Grid>
              </Grid>
              </CardContent>
            </Card>
            <div style={{ paddingRight: "5px", textAlign:"right"}}>
                  <React.Fragment>
                      <Tooltip title={"Save"}>
                          <IconButton onClick={handleModalSave}>
                              <SaveIcon />
                          </IconButton>
                      </Tooltip>
                      <Tooltip title={"Cancel"}>
                          <IconButton onClick={handleModalClose}>
                              <Clear />
                          </IconButton>
                      </Tooltip>
                  </React.Fragment>
                </div>
          </Grid>
        </Grid>
      </div>
    );
  
    return (
      <div className={classes.root}>
        {doneLoading && enabled ? (
          <TableAbstraction
            settingsKey="ADM_EQM"
            options={{
              draggableColumns: {
                enabled: true,
              },
              rowsPerPageOptions: [25, 50, 100],
              serverSide: false,
              selectableRows: "none",
              rowsPerPage: muiTable.rpp,
              onChangeRowsPerPage: (numberOfRows) => {
                muiTable.rpp = numberOfRows;
                setMuiTable(muiTable);
              },
              customToolbar: () => {
                return (
                  <Tooltip title={`Add Bottle/Can Config`}>
                    <IconButton  onClick={() => {
                      handleModalClose();
                      setOpenEditWindow(true);
                      setMode('add');
                     
                    }}>
                      <AddIcon />
                    </IconButton>
                  </Tooltip>
                );
              },
            }}
            title="Bottle/Can Configuration"
            columns={[
              {
                label: "Delivery Plant",
                name: "config_dp",
                options: {
                  searchable: true,
                  filter: false,
                  hint: " configuration is applicable on delivery plant.(This configuration is used to overide machine type (BOTTLE/CAN/Mix))",
                },
              },
              {
                label: "Type Overide",
                name: "type_override",
                options: {
                  searchable: true,
                  filter: false,
                   hint: "This is to set up The particular configuration is the bottle/can/mix type"
                },
              },
              {
                label: "Machine Type",
                name: "machine_type",
                options: {
                  searchable: true,
                  filter: false,
                   hint: "This  option to identify machine type"
                },
              },
              {
                label: "Group",
                name: "group_by",
                options: {
                  searchable: true,
                  filter: false,
                   hint: "This option is to identify the configuration is on the matrial number or BPP wise. Priority would go to Material Number if same configuration would be be available in the system"
                },
              },
              {
                label: "Material Number",
                name: "material_num",
                options: {
                  searchable: true,
                  filter: false,
                },
              },
              {
                label: "Beverage Product",
                name: "beverage_product",
                options: {
                  customBodyRender: (value: any) =>
                    `${determineConfig(codes, "BEVERAGEPRODUCT", value)}` || "",
                },
              },
              {
                label: "Pack Type",
                name: "pack_type",
                options: {
                  customBodyRender: (value: any) =>
                    `${determineConfigLong(codes, "PACKTYPE", value)}` || "",
                },
              },
              {
                label: "Pack Size",
                name: "pack_size",
                options: {
                  customBodyRender: (value: any) =>
                    `${determineConfig(codes, "PACKSIZE", value)}` || "",
                },
              },
              
              
              {
                label: " ",
                name: "remove",
                options: {
                  filter: false,
                  setCellProps: () => ({ align: 'right' }),
                  renderCell: (params) => {
                    if(!!useCompact)
                      return (
                          <React.Fragment>
                            <Tooltip title={"Edit"}>
                              <EditIcon 
                                fontSize="small"  
                                onClick={() => {handleEdit(params.row)}}/>
                            </Tooltip>
                            <Tooltip title={"Delete"}>
                              <DeleteIcon
                                fontSize="small" 
                                onClick={() => {setCurrent(params.row); setopenDeleteWindow(true);}} 
                              />
                            </Tooltip>
                          </React.Fragment>
                        );
                      else
                        return (
                            <React.Fragment>
                              <Tooltip title={"Edit"}>
                                <IconButton onClick={() => {handleEdit(params.row)}}>
                                  <EditIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={"Delete"}>
                                <IconButton onClick={() => {setCurrent(params.row); setopenDeleteWindow(true);}}>
                                  <DeleteIcon />
                                </IconButton>
                              </Tooltip>
                            </React.Fragment>
                          );
                  },
                },
              },
            ]}
            data={bottleCanConfig}
          />
        ) : ( enabled ? (
          <div className={classes.centerDiv}>
            <CircularProgress color="primary" />
          </div>) : (
            <Alert severity="error">
              <AlertTitle><LockIcon/> Access Error</AlertTitle>   
              You do not currently have access to <strong>Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
            </Alert>
          )
        )}
         <Modal
                  open={openEditWindow}
                  onClose={handleModalClose}
              >
                  {modalBody}
  
              </Modal>
              <Dialog
              open={openDeleteWindow}
              onClose={handleModalClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                Are you sure you want to delete this configuration ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={()=>{handleDelete(); setopenDeleteWindow(false);}} color="primary">
                  Yes
                </Button>
                <Button onClick={()=>{setEditedRow(undefined); setopenDeleteWindow(false);}} color="primary" autoFocus>
                  No
                </Button>
              </DialogActions>
        </Dialog>
      </div>
    );
}